import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  background: ${Theme.colors.bgGrey};
  margin-bottom: 10px;
`

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 20px;
  width: 100%;
  align-items: stretch;
  
  @media(max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  
  @media(max-width: 1199px) {
    order: 1;
  }
`

export const LoadingContainer = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`
